import type { ApPayeeDetailAllOfPaymentMethod } from 'ap-openapi';

/**
 * 支払い方法のラベルを取得する / Get the payment method label
 * @param paymentMethod 支払い方法 / Payment method
 * @param t 翻訳関数 / Translation function
 * @returns 支払い方法のラベル / Payment method label
 */
export const getPaymentMethodLabel = (
  paymentMethod: ApPayeeDetailAllOfPaymentMethod | undefined | null,
  t: (key: string) => string
): string => {
  if (!paymentMethod) return '';

  const paymentMethodKey =
    `payee_payment_method_label_${paymentMethod}` as const;

  const knownMethods = [
    'bank_transfer',
    'cash',
    'payment_slip',
    'direct_debit',
    'credit_card',
    'prepaid_card',
    'check',
    'promissory_note',
    'densai',
    'remittance_abroad',
    'other',
  ] as const;

  if (!knownMethods.includes(paymentMethod)) {
    return '';
  }

  return t(paymentMethodKey);
};
